import querystring from 'query-string';
/**
 * 获得querystring
 *
 * @return {object} 返回qs
 */
 export function getQS(): any {
    const posInSearch = location.search.indexOf('?');
    return querystring.parse(location.search.substr(posInSearch + 1))
}